<template>
  <div class="fold flex flex-ali-center flex-center" :class="`fold-${isCol ? 'col' : 'row'}`">
    <div class="arrow pointer" :class="arrowReverse && 'reverse'" @click="inFoldSwitch(foldKey)"></div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    //是否上下折叠 默认左右折叠
    isCol: {
      type: Boolean,
      default: false
    },
    //方向反置
    reverse: {
      type: Boolean,
      default: false
    },
    //折叠对象key fold.js
    foldKey: {
      type: String,
      required: true
    },
  },
  data() {
    return {
    };
  },
  computed:{
    arrowReverse(){
      return this.$store.state[this.foldKey] ? !this.reverse : this.reverse
    }
  },
  mounted(){
  },
  methods:{
    ...mapActions(['foldSwitch']),
		inFoldSwitch(foldKey){
			this.foldSwitch(foldKey)
			this.$emit('isSwitch')
		}
		
  }
};
</script>
<style lang="less" scoped>
  @size: 20px;
  @arrowSize: 100px;
  .fold{
    position: relative;
    .arrow{
      background: #eee;
      &:hover{
        background-color: #FC6;
      }
      &::before{
        content: "";
        transition: .3s;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        border: 7px solid transparent;
      }
      &.reverse{
        &::before{
          transform: translate(-50%, -50%) rotate(180deg);
        }
      }
    }
    &.fold-row{
      width: @size;
      height: 100%;
      .arrow{
        width: 100%;
        height: @arrowSize;
        &::before{
          border-right-color: #000000;
          border-left: unset;
        }
      }
    }
    &.fold-col{
      width: 100%;
      height: @size;
      .arrow{
        width: @arrowSize;
        height: 100%;
        &::before{
          border-bottom-color: #000000;
          border-top: unset;
        }
      }
    }
  }
</style>
